import type { SessionUser } from '@headline/schemas'

/**
 * Is this session Clipbook staff — the platform plane. The API decides it (`isClipbookStaff` in
 * apps/api/src/lib/staff.ts: `manage-all:accounts` AND a session in Clipbook's own organization)
 * and says so as `staff` on `/api/auth/me`; the SPA never re-derives it from the permission, which
 * cannot tell a customer's admin from Clipbook's (CLI-905). The whole SPA reads staff-ness here.
 *
 * This is a UX/presentation signal, never a security boundary — the API gates on the permission
 * itself (`requirePermission` / `requireResourcePermission`), which a client check can't substitute.
 */
export function isStaff(user: SessionUser | null | undefined): boolean {
  return user?.staff ?? false
}
